export default "__VITE_ASSET__C_VlA1Vu__"